import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

import PageHeader from '../../components/PageHeader.jsx';
import { ErrorBox } from '../../components/Loader.jsx';
import ComplaintForm from './ComplaintForm.jsx';
import { ComplaintsAPI } from '../../lib/api';
import { buildPath, complaintCapabilities } from '../../config';
import { useAuth } from '../../lib/auth.jsx';

export default function ComplaintCreate() {
  const navigate = useNavigate();
  const { user } = useAuth();
  const can = complaintCapabilities(user);
  const [error, setError] = useState(null);
  const [submitting, setSubmitting] = useState(false);

  const onSubmit = async (payload) => {
    setSubmitting(true);
    setError(null);
    try {
      const created = await ComplaintsAPI.create(payload);
      navigate(buildPath.complaintDetails(created.id));
    } catch (e) {
      setError(e);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <>
      <PageHeader
        title="Create Complaint"
        subtitle={
          can.isIndividual
            ? 'Log a complaint assigned to you.'
            : 'Log a new complaint and route it to the correct division.'
        }
      />
      <ErrorBox error={error} />
      <ComplaintForm onSubmit={onSubmit} submitting={submitting} mode="create" />
    </>
  );
}
